/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 1b8b3abca32e2944b8fba3ab2fea012630968b0b
 */

export type OrganizationStatus = typeof OrganizationStatus[keyof typeof OrganizationStatus];


export const OrganizationStatus = {
  pending: 'pending',
  active: 'active',
  suspended: 'suspended',
} as const;
